<script>
import Label from '../form-components/Label.vue'
import Multiselect from "vue-multiselect";

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        last_updated: {
            type: Object,
            required: false
        },
        selectedItem: {
        type: Object,
        required: false
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label, Multiselect
    },
    data() {
        return {
            value: '',
            options: [],
            display_none_check: this.selectedItem ? JSON.stringify(this.selectedItem[this.item.displayOn]) == this.item.displayOnValue ? false : true : true
        };
    },
    watch: {
        last_updated: {
            handler(val) {
                if(val && this.item.displayOn && val.key == this.item.displayOn) {                    
                    this.display_none_check = JSON.stringify(val.value) == this.item.displayOnValue ? true : false;
                }
            },
            deep: true
        },
        item_value: {
            handler(val) {
                this.value = this.options.filter(x => x == val)[0];
            },
            deep: true
        },
        value(val) {
            if(val) {
                this.updateValue(this.item_key, val);
            }
        }
    },
    methods: {
        async getOptions() {
            this.options = ['Get Help With', 'Appointments', 'Keep Us Updated', 'New Patients', 'Feedback']
            this.value = this.options.filter(x => x == this.item_value)[0];
        }
    },
    mounted() {
        this.getOptions();
    }
};
</script>
<template>
    <div class="mb-3" :class="{ 'd-none': item.displayOn && !display_none_check}">
        <Label :item="item"/>
        <multiselect
            v-model="value"
            :options="options"
            :searchable="options.length > 5 ? true : false"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="item.placeholder"
            :allow-empty="false"
            :preselectFirst="true"
        >
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option }}</strong></template>
        </multiselect>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>